<script>
export default {
  name: 'ShareIcon',
};
</script>

<template>
  <path
    d="M9.77279 0.414282C9.44336 0.560375 9.22852 0.889802 9.22852 1.25074V3.08407H6.02018C3.23581 3.08407 0.978516 5.34136 0.978516 8.12574C0.978516 11.3713 3.31315 12.8208 3.84883 13.113C3.92044 13.1531 4.00065 13.1674 4.08086 13.1674C4.3931 13.1674 4.64518 12.9125 4.64518 12.6031C4.64518 12.3882 4.52201 12.1906 4.36445 12.0445C4.09518 11.7895 3.72852 11.2882 3.72852 10.4174C3.72852 8.89918 4.96029 7.66741 6.47852 7.66741H9.22852V9.50074C9.22852 9.86168 9.44049 10.1911 9.77279 10.3372C10.1051 10.4833 10.4889 10.4231 10.7582 10.1825L15.3415 6.05751C15.5335 5.88277 15.6452 5.63642 15.6452 5.37574C15.6452 5.11506 15.5363 4.86871 15.3415 4.69397L10.7582 0.568969C10.4889 0.325479 10.1022 0.265323 9.77279 0.414282Z"
  />
</template>
